import { useState, useEffect } from "react";


const getLocalItem = (nameKey) => {
  return localStorage.getItem(nameKey);
}

const useLocalStorage = (key, initialValue) => {
  const [value, setValue] = useState(initialValue || getLocalItem(key));

  useEffect(() => {
    localStorage.setItem(key, value);
  }, [value]);

  //   const setItem = newValue => {
  //     setValue(newValue)
  //     // localStorage.setItem(key, newValue)
  //   }

  const removeItem = () => {

    localStorage.removeItem(key);
    setValue(initialValue);
  };

  return [value, setValue, removeItem];
};

export default useLocalStorage;
